let cartCheckPromise = null;

window.hasArgosPreOrder = null;
window.hasScratchDentPreOrder = null;

function initializeValidateTermsListener() {
  const checkoutButton = document.getElementById('checkout');
  if (!checkoutButton) return;

  const error = document.getElementById('cancellation-error');
  if (!error) return;

  checkoutButton.addEventListener('click', (e) => {
    // If cart state hasn't loaded yet, wait for it then re-trigger the click
    if (window.hasArgosPreOrder === null || window.hasScratchDentPreOrder === null) {
      e.preventDefault();
      (cartCheckPromise || checkPreOrders()).then(() => checkoutButton.click());
      return;
    }

    const hasAnyPreOrder = window.hasArgosPreOrder || window.hasScratchDentPreOrder;
    if (!hasAnyPreOrder) return;

    const termIds = ['cancellation-fee'];
    if (window.hasArgosPreOrder) termIds.push('shipping-estimate');
    if (window.hasScratchDentPreOrder) termIds.push('shipping-estimate-scratch');

    const allChecked = termIds.every((id) => {
      const el = document.getElementById(id);
      return el && el.checked;
    });

    if (!allChecked) {
      e.preventDefault();
      error.style.display = 'block';
      alert('You must agree to the cancellation terms before proceeding to checkout.');
    }
  });
}

function addToggleListener(containerId, labelId, checkboxId, errorId) {
  const container = document.getElementById(containerId);
  const label = document.getElementById(labelId);
  const checkbox = document.getElementById(checkboxId);
  const error = document.getElementById(errorId);

  if (!container || !label || !checkbox || !error) return;

  checkbox.addEventListener('change', () => {
    if (checkbox.checked) {
      error.style.display = 'none';
    }
  });

  label.addEventListener('click', (e) => {
    // prevent double toggle when clicking on the label
    e.stopPropagation();
  });

  container.addEventListener('click', (e) => {
    // only toggle if the click is outside the checkbox itself
    if (e.target.tagName !== 'INPUT') {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change'));
    }
  });
}

function showTermsIfPreOrderInCart() {
  const argosShippingContainer = document.getElementById('shipping-estimate-container');
  const scratchShippingContainer = document.getElementById('shipping-estimate-container-scratch');
  const cancellationContainer = document.getElementById('cancellation-fee-container');
  const error = document.getElementById('cancellation-error');

  checkPreOrders().then(() => {
    const hasAnyPreOrder = window.hasArgosPreOrder || window.hasScratchDentPreOrder;
    if (argosShippingContainer) argosShippingContainer.style.display = window.hasArgosPreOrder ? 'block' : 'none';
    if (scratchShippingContainer)
      scratchShippingContainer.style.display = window.hasScratchDentPreOrder ? 'block' : 'none';
    if (cancellationContainer) cancellationContainer.style.display = hasAnyPreOrder ? 'block' : 'none';
    if (error && !hasAnyPreOrder) error.style.display = 'none';
  });
}

function checkPreOrders() {
  cartCheckPromise = fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      window.hasArgosPreOrder = cart.items.some((item) =>
        ['argos-espresso-machine', 'argos-espresso-machine-without-steam-wand-pre-order'].includes(item.handle)
      );
      window.hasScratchDentPreOrder = cart.items.some(
        (item) => item.handle === 'scratch-and-dent-argos-espresso-machine-pre-order'
      );
    });
  return cartCheckPromise;
}

function updateAttributes() {
  checkPreOrders().then(() => {
    const hasAnyPreOrder = window.hasArgosPreOrder || window.hasScratchDentPreOrder;

    const shippingParts = [];
    if (window.hasArgosPreOrder) {
      shippingParts.push(
        'I understand that the current estimated shipping date for the Argos is 4 months from the order date and it is subject to delays.'
      );
    }
    if (window.hasScratchDentPreOrder) {
      shippingParts.push(
        'I understand that the current estimated shipping date for the Scratch & Dent Argos is 3 months from the order date and it is subject to delays.'
      );
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          shipping_estimate_acknowledged: shippingParts.join(' '),
          cancellation_fee_acknowledged: hasAnyPreOrder
            ? 'I understand that pre-order cancellations are subject to a 3% non-refundable processing fee. If I cancel my order, I will receive a 97% refund.'
            : '',
        },
      }),
    }).then((c) => c.json());
  });
}

function listenToRemoveItem() {
  document.addEventListener('click', (e) => {
    if (e.target.closest('cart-remove-button')) {
      setTimeout(() => {
        showTermsIfPreOrderInCart();
        updateAttributes();
      }, 750);
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  showTermsIfPreOrderInCart();
  updateAttributes();
  addToggleListener('cancellation-fee-container', 'cancellation-fee-label', 'cancellation-fee', 'cancellation-error');
  addToggleListener(
    'shipping-estimate-container',
    'shipping-estimate-label',
    'shipping-estimate',
    'cancellation-error'
  );
  addToggleListener(
    'shipping-estimate-container-scratch',
    'shipping-estimate-label-scratch',
    'shipping-estimate-scratch',
    'cancellation-error'
  );
  initializeValidateTermsListener();
  listenToRemoveItem();
});
